<template>
  <Page :response="response">
    <div>
      <div class="form-links mb-4 mt-2 mb-md-0 mt-md-0 px-i">
        <div class="form-links-wrapper justify-content-center container-fluid">
          <div class="btn-group filter-group">
            <a :href="`dashboard#/invoices/${invoiceReport.invoice_hash_token}`" class="btn btn-outline-primary filter-group-button col-8"> Invoice </a>
            <a href="#" class="btn btn-outline-primary filter-group-button col-8 active"> Receipt </a>
            <a v-if="showPayoutTab" :href="`dashboard#/invoices/${invoiceReport.invoice_hash_token}/payout`" class="btn btn-outline-primary filter-group-button col-8"> Payout </a>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <CardForm
          section-title="Payment Confirmation"
          class="mt-3 mb-0">
          <div class="invoice-details">
            <div class="invoice-details-info col-24 col-md-12">
              <div class="invoice-details-info-row">
                <div class="invoice-details-info-row-start">
                  Payment Date
                </div>
                <div class="invoice-details-info-row-end">
                  {{ invoiceReport.invoice_payment_date | formatDateTime(true) }}
                </div>
              </div>
              <div class="invoice-details-info-row">
                <div class="invoice-details-info-row-start">
                  Payment Method
                </div>
                <div class="invoice-details-info-row-end">
                  {{ invoiceReport.invoice_payment_method_name }}
                </div>
              </div>
            </div>
            <div class="invoice-details-info col-24 col-md-12">
              <div class="invoice-details-info-row">
                <div class="invoice-details-info-row-start">
                  Transaction Reference
                </div>
                <div class="invoice-details-info-row-end">
                  {{ invoiceReport.transaction_reference }}
                </div>
              </div>
              <div class="invoice-details-info-row">
                <div class="invoice-details-info-row-start">
                  Card Number
                </div>
                <div class="invoice-details-info-row-end">
                  {{ invoiceReport.credit_card_number }}
                </div>
              </div>
            </div>
          </div>

          <div class="invoice-description-table">
            <div class="invoice-table">
              <div class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Invoice Total
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.invoice_total | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>

              <div v-if="invoiceReport.customer_fawter_fee > 0" class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Fawter Fee {{ vatInclusiveAsterisk }}
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.customer_fawter_fee | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>

              <div v-if="invoiceReport.customer_payment_fee > 0" class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Payment Fee
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.customer_payment_fee | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>

              <div class="invoice-table-row px-i">
                <div class="invoice-table-row-start">
                  Total Paid
                </div>
                <div class="invoice-table-row-end">
                  {{ invoiceReport.payment_total | formatCurrency(invoiceReport.invoice_currency_iso_code, currencyMinimumDigits) }}
                </div>
              </div>
            </div>
            <div v-if="invoiceReport.customer_fawter_fee_vat_rate" class="invoice-table-mention">
              *inclusive of VAT ({{ invoiceReport.customer_fawter_fee_vat_rate | formatPercentage }})
            </div>
          </div>
        </CardForm>
      </div>
    </div>
  </Page>
</template>

<script>
import store from "./InvoiceStore";
import InvoiceMixin from "./InvoiceMixin";
import CardForm from "../../../shared/components/UI/CardForm.vue";

const responseStore = {
  response: null
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetchReceipt(to.params.hash);

  next();
};

export default {
  name: "InvoiceReceipt",

  components: {
    CardForm
  },

  mixins: [InvoiceMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      store: store
    };
  },

  computed: {
    invoiceReport () {
      return this.responseStore.response.invoiceReport;
    },

    paidInvoice () {
      return this.invoiceReport.invoice_status === "paid";
    },

    userIsMerchant () {
      return this.currentUser && this.invoiceReport.invoice_created_by_user_id === this.currentUser.id;
    },

    currentUser () {
      return Dashboard.currentUser;
    },

    showPayoutTab () {
      return this.userIsMerchant && this.paidInvoice;
    },

    currencyMinimumDigits () {
      if (this.invoiceReport.invoice_currency_iso_code === "LBP") {
        return 0;
      } else {
        return 2;
      }
    },

    vatInclusiveAsterisk () {
      if (this.invoiceReport.customer_fawter_fee_vat_rate) {
        return "*";
      } else {
        return "";
      }
    }
  },

  mounted () {
    this.addBreadcrumb(`${this.invoiceReport.invoice_merchant_number} - ${this.invoiceReport.invoice_subject} / Receipt`);
  }
};
</script>
